import { useState, useCallback } from 'react';
import { Check, Copy } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

export default function CodeBlock({ className, children }) {
  const { t } = useTranslation('chat');
  const [copied, setCopied] = useState(false);

  const language = className?.replace('language-', '') || '';
  const code = String(children).replace(/\n$/, '');

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }, [code]);

  return (
    <div className="group relative my-3 rounded-lg border border-border overflow-hidden">
      <div className="flex items-center justify-between bg-muted/50 px-4 py-1.5 text-xs text-muted-foreground">
        <span className="font-mono">{language || 'code'}</span>
        <Button
          variant="ghost"
          size="sm"
          className="h-6 gap-1 px-2 text-xs"
          onClick={handleCopy}
        >
          {copied ? (
            <>
              <Check className="size-3" />
              {t('copied', 'Copied!')}
            </>
          ) : (
            <>
              <Copy className="size-3" />
              {t('copy_code', 'Copy')}
            </>
          )}
        </Button>
      </div>
      <pre className="overflow-x-auto p-4 text-sm">
        <code className={className}>{children}</code>
      </pre>
    </div>
  );
}
